import { IAppState } from '../../common/state';

export const getNewbuildingBrokerSettings = (state: IAppState) => state.featureToggle.newbuildingBrokerSettings;
